import { render, staticRenderFns } from "./versatileAnswersRecord.vue?vue&type=template&id=239584e9&scoped=true"
import script from "./versatileAnswersRecord.vue?vue&type=script&lang=js"
export * from "./versatileAnswersRecord.vue?vue&type=script&lang=js"
import style0 from "./versatileAnswersRecord.vue?vue&type=style&index=0&id=239584e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239584e9",
  null
  
)

export default component.exports